<template>
<div class="modal-root" >
  <LxpMobileHeader title="SSL - 자격증 목표 설정">
    <template v-slot:left>
      <div class="util util-back">
        <a href="javascript:" class="util-actions util-actions-back" @click="goBack">
          <i class="icon-history-back"></i>
        </a>
      </div>
    </template>
    <template v-slot:right>
      <div class="util util-download">
        <button class="util-actions util-actions-yellow" @click="clickSave">
          저장
        </button>
      </div>
    </template>
  </LxpMobileHeader>
  <!-- begin::kb-main -->
  <main class="kb-main" id="kb-talentboard-goal">
    <!-- main-content -->
    <div class="main-content min-component">
      <div class="goal-setting-container">

        <section class="content-section ">
          <header class="section-header">
            <h4 class="title">취득희망 자격증</h4>
          </header>

            <div class="header-sub">
              <strong class="text text-muted">취득 희망 자격증 최대 2개 선택 가능</strong>
            </div>

            <div class="roundedbox-bottom d-flex my-4">
              <span class="text" style="font-weight: bold;"> 선택 목표:</span>
              <div class="section-body" v-for="sel in selectedLcsns" :key="sel">
                <span class="license-button" @click="searchLcsnNm(sel.lcsnNm)">{{sel.lcsnNm}}</span>
              </div>
            </div>

          <div class="kb-form-search mb-3" style="align-items: center;">
            <div class="kb-form-search-field w-100">
              <input v-model.trim="filters.keyword" type="text" class="kb-form-search-input" placeholder="자격증 검색하세요" @keyup.enter="getLicenseList(1)">
              <button class="kb-form-search-btn" @click="getLicenseList(1)"><i class="icon-search">검색</i></button>
            </div>
          </div>

          <div  v-if="goalLicenses && goalLicenses.length > 0" class="section-content ">
            <div class="kb-form-check-group">
              <!-- kb-form-check -->
              <div v-for="(license, index) in goalLicenses" :key="index" class="kb-form-check kb-form-check-divider">
                <span v-if="isDisabledLicense(license.lcsnCd)">선택불가</span>
                <input v-else-if="!isLicenseGet(license.lcsnCd)" v-model="selected" type="checkbox" class="kb-form-check-input" :id="`chk_list_${license.lcsnCd}`" name="chk_list" :value="license.lcsnCd" @change="checkLicense(license)"/>
                <span v-else></span>
                <label :for="`chk_list_${license.lcsnCd}`" class="kb-form-check-label">
                  <span class="label-text text-skip" style="width: 250px">{{ license.lcsnNm }} - {{ license.pblcnInstNm }} - {{ license.lcsnCd }}</span>
                  <span class="label-subtext">{{ license.grd1Cd }} ㅣ {{ isLicenseGet(license.lcsnCd) ? '취득' : '미취득' }}</span>
                </label>
              </div>

              <!-- kb-form-check -->
            </div>
            <CommonPaginationFront
              :paging="paging" :page-func="getLicenseList"
              :page-list-size="5"
            />
          </div>

          <div v-else  class="section-conten text-center section-divider" style="padding-top:15px;">
            <span class="text"  style="color:#111; font-weight: bold; font-size:16px;margin-top:15px;" >자격증명을 검색하여 선택 후 저장</span>
            <div class="m-2" style="text-align:left; word-break:keep-all;">
              <p class="text-muted mb-1">[PB직무]<br> 자산관리사(FP), 한국재무설계사(AFPK), 투자자산운용사</p>
              <p class="text-muted mb-1">[기업직무] <br> 신용분석사, 국제무역사 1급, 외환전문역 1종, 외환전문역 2종</p>
              <p class="text-muted">[기타]<br> KB스타런 內 등록 가능한 모든 자격증</p>
            </div>

          </div>
        </section>
      </div>
    </div>
    <!-- //main-content -->
  </main>
</div>
</template>

<script>
import { computed, reactive, ref, watch } from "vue";
import {
  closeToggles,
  // datePartToFormat,
  getListFunc} from '@/assets/js/ui.init';
import {isSuccess} from '@/assets/js/util';
import {
  ACT_GET_SSL_REG_LCSN_LIST,
  ACT_GET_LRN_LCSN_LIST, ACT_GET_LRN_SPRT_LCSN_LIST
} from "@/store/modules/license/license";
import CommonPaginationFront from '@/components/CommonPaginationFront.vue';
import {useAlert} from '@/assets/js/modules/common/alert';
import {useStore} from 'vuex';
// import {ACT_INSERT_LRN_CRSE_WORK_GOALS, ACT_UPDATE_LRN_CRSE_WORK_GOALS} from '@/store/modules/talent/talent';
// import {isSuccess} from '@/assets/js/util';
import {ACT_INSERT_SOC_LCSN_STAT_ACT} from "@/store/modules/ssl/ssl-index";
import LxpMobileHeader from "@/views/layout/lxp/header/mobile/LxpMobileHeader";
import {goBack} from '@/assets/js/modules/common/common';
import { useRoute } from "vue-router";
export default {
  name: "SSLMobileLicRegModal",
  components: {
    CommonPaginationFront,
    LxpMobileHeader,
  },
  setup(){
    const route = useRoute();
    const store = useStore();
    const {showMessage, showConfirm} = useAlert();
    const lrnTrgtGrpMstSn = computed(() => (route.query && route.query.lrnTrgtGrpMstSn));
    const session = computed(() => store.state.auth.session);

    const maxLimitText = 500;
    const licenseLimit = 2;
    const disabledLicenses = ['WR96'];


    const params = reactive({
      goalsEndYmd: '',
      // goalsCn: props.hopeGoal.goalsCn,
      lcsnLst: '',
    });

    const toggles = reactive({
      works: false,
      now: false,
      hope: false,
      date: false,
    });

    // 기선택 자격증 조회


    const goalLicenses = ref([]);
    const selected = ref([]);
    const selectedLcsns = ref([]);
    const getSocSelList = ref([]);
    // 취득자격증 조회


    const getLcsnList = ref([]);
    const getLcsnCodes = computed(()=>  getLcsnList.value.map(x => x.lcsnCd));

    getListFunc(`license/${ACT_GET_LRN_SPRT_LCSN_LIST}`, {regYn: 'Y'}, getLcsnList, null, () => {});

    getListFunc(`license/${ACT_GET_SSL_REG_LCSN_LIST}`, {lrnerId: session.value.lrnerId}, getSocSelList, null, () => {
      selected.value = getSocSelList.value.map(x => x.lcsnCd)
      selectedLcsns.value = getSocSelList.value.map(( {lrnTrgtGrpMstSn,lcsnCd, lcsnNm} )=> ({lrnTrgtGrpMstSn,lcsnCd, lcsnNm}));
    });

    // const getSSLRegLicList = (pageNo)=>{
    //   getListFunc(`license/${ACT_GET_LRN_LCSN_LIST}`, {sortCd: 'g', pageNo: paging.pageNo, pageSize: paging.pageSize, ...filters}, params.lcsnLst,
    //     {   pageNo: 1,pageSize: 2,totalCount: 2}, () => {
    //       selected.value = [...new Set(goalLicenses.value.map( g => g.lcsnCd))].filter(cd => selectedLcsns.value.some(s => s.lcsnCd === cd));
    //     });
    // }

    // const licenseCodes = computed(() => props.licenses.map(x => x.lcsnCd))

    const filters = reactive({
      keyword: ''
    });

    const paging = reactive({
      pageNo: 0,
      pageSize: 5,
      totalCount: 0
    });

    const goalDate = ref(null);

    // if(props.hopeGoal.crseWorkDtlSn > 0 && props.hopeGoal.goalsEndYmd){
    //   const split = props.hopeGoal.goalsEndYmd.split('-');
    //   if(split.length === 3){
    //     const dateSplit = split.map(x => parseInt(x));
    //     goalDate.value = {
    //       year: dateSplit[0],
    //       month: dateSplit[1],
    //       day: dateSplit[2]
    //     }
    //   }
    // }

    const goalsCnCount = computed(() => {
      if(params.goalsCn){
        return params.goalsCn.length;
      }
      return 0;
    });

    watch(() => goalLicenses.value, () => {




    })

    //자격증 전체리스트
    const getLicenseList = (pageNo) => {
      //getSSLRegLicList();
      paging.pageNo = pageNo ? pageNo : 1;
      getListFunc(`license/${ACT_GET_LRN_LCSN_LIST}`, {sortCd: 'g', pageNo: paging.pageNo, pageSize: paging.pageSize, lcsnNm:filters.keyword  }, goalLicenses, paging, () => {});
    }

    const isLicenseGet = (code) => {
      return getLcsnCodes.value.includes(code);
    }

    const isDisabledLicense = (code) => {
      return disabledLicenses.includes(code);
    }



    const checkLicense = (license) => {
      // length 체크
      const code = license.lcsnCd
      const name = license.lcsnNm

      const isChecked = selected.value.includes(code);

      if(isChecked){
        if(!selectedLcsns.value.some(it => it.lcsnCd === code)){
          if(selectedLcsns.value.length >= licenseLimit){
            selected.value = selected.value.filter(c=> c!==code);
            showMessage('취득희망 자격증은 최대 2개만 선택할 수 있습니다.');
            return;
          }else{
            selectedLcsns.value.push({lrnTrgtGrpMstSn: lrnTrgtGrpMstSn,lcsnCd: code, lcsnNm: name})
          }
        }
      }else{
        selectedLcsns.value = selectedLcsns.value.filter(item => item.lcsnCd !== code)
      }
      //   if(selected.value.length > licenseLimit){
      //     if(selected.value.filter(x => !getLcsnList.value.includes(x)).length > licenseLimit){
      //       selected.value.splice(selected.value.indexOf(code), 1);
      //       showMessage('취득희망 자격증은 최대 2개만 선택할 수 있습니다.');
      //     }
      //   }else {
      //     if (!selectedLcsns.value.some(item => item.lcsnCd === code)) {
      //       selectedLcsns.value.push({lrnTrgtGrpMstSn: lrnTrgtGrpMstSn,lcsnCd: code, lcsnNm: name})
      //     }
      //   }
      // }else{
      //   selectedLcsns.value = selectedLcsns.value.filter(item => item.lcsnCd !== code)
      // }

    }

    const closeModal = () => {
     goBack();
    };

    const validateParams = () => {
      let result = true;

      return result;
    };

    const isLoading = ref(false);

    const saveGoals = () => {
      if(selectedLcsns.value.length === 0){
        showMessage('하나 이상의 자격증 목표를 설정해야 합니다.');
        isLoading.value = false;
      }else {
        store.dispatch(`ssl/${ACT_INSERT_SOC_LCSN_STAT_ACT}`, selectedLcsns.value).then(res => {
          isLoading.value = false;

          if (isSuccess(res)) {
            showMessage('SSL 자격증 취득 목표가 설정되었습니다.');
            // emit('completed');
            closeModal();
          } else {
            showMessage('오류가 발생했습니다. 다시 시도해주세요.');
          }

        }).catch(e => {
          console.error(e);
          showMessage('오류가 발생했습니다. 다시 시도해주세요.');
        });
      }

    }

    const searchLcsnNm =  (lcsnNm) =>{
      filters.keyword = lcsnNm;
      getLicenseList(1)
    }

    const clickSave = () => {
      if(isLoading.value) return;

      if(validateParams()){
        isLoading.value = true;
        showConfirm({
          title: 'SSL 자격증취득 목표 설정',
          text: '최대 2개의 목표를 설정할 수 있습니다. <br> 자격증 목표를 설정하시겠습니까?',
          callback: saveGoals,
          closeCallback: () => {
            isLoading.value = false;
          },

        });
      }
    }

    // getLicenseList();


    return {
      maxLimitText,
      params,
      toggles,
      goalDate,
      goalLicenses,
      goalsCnCount,
      selected,
      paging,
      session,
      filters,
      clickSave,
      getLicenseList,
      isLicenseGet,
      isDisabledLicense,
      checkLicense,
      closeModal,
      closeToggles,
      selectedLcsns,
      goBack,
      searchLcsnNm,
    }
  }
};
</script>
<style>
.license-button{border-radius:8px; background-color: #F7F4F0; color:#84888B; font-size:12px; font-weight: bold; border: 1px solid #E8E8E8; padding: 7px; height: 15px; margin:5px 2px;}
.section-divider {border-top:1px solid var(--kb-border-color)}
</style>
